import {
  Autocomplete,
  AutocompleteProps,
  CircularProgress,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { RiArrowDownSLine } from "react-icons/ri";

interface GKSearchSelectProps {
  inputLabel?: string;
  requiredField?: boolean;
}

const GKSearchSelect = (
  props: GKSearchSelectProps & AutocompleteProps<any, any, any, any, any>
) => {
  const {
    inputLabel,
    requiredField,
    loading,
    options,
    getOptionLabel,
    disableClearable = true,
  } = props;

  const [initialSliceValue, setInitialSliceValue] = useState(50);

  const [searchText, setSearchText] = useState("");

  const handleFilterOptions = (option: any) => {
    const normalizedSearchTerm = searchText
      ?.toString()
      ?.toLowerCase()
      ?.replace(/\s/g, "");

    const filteredData = option?.filter((company: any) =>
      Object.values(company).some((value) => {
        return (
          value !== null &&
          value
            ?.toString()
            ?.toLowerCase()
            ?.replace(/\s/g, "")
            ?.includes(normalizedSearchTerm)
        );
      })
    );

    return (
      [...new Set([...filteredData, ...options])]?.slice(
        0,
        initialSliceValue
      ) || []
    );
  };

  const handleScroll = (event: any) => {
    const listboxNode = event.currentTarget;
    const position = listboxNode.scrollTop + listboxNode.clientHeight;
    if (listboxNode.scrollHeight - position <= 1) {
      setInitialSliceValue(initialSliceValue + 100);
    }
  };

  return (
    <Autocomplete
      {...props}
      disableClearable={disableClearable}
      getOptionLabel={getOptionLabel}
      ListboxProps={{
        onScroll: handleScroll,
      }}
      filterOptions={handleFilterOptions}
      options={handleFilterOptions(options)}
      onInputChange={(event, val) => {
        setSearchText(val);
      }}
      componentsProps={{
        popper: {
          placement: "bottom",
        },
      }}
      slots={{}}
      popupIcon={
        loading ? (
          <CircularProgress size={16} />
        ) : (
          <RiArrowDownSLine size={16} />
        )
      }
      ChipProps={{
        deleteIcon: <IoMdClose size={16} />,
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={inputLabel}
          fullWidth
          slotProps={{
            inputLabel: {
              required: requiredField,
              sx: {
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              },
            },
          }}
        />
      )}
    />
  );
};

export default GKSearchSelect;
